import { useCallback, useEffect, useState } from "react";
import {
  EducationRecordAccessLogEntry,
  listEducationRecordAccessLog,
} from "services/educationRecordAccessLog";

const PAGE_SIZE = 50;

export type AccessLogFilters = {
  q?: string;
  action?: string;
};

export function useEducationRecordAccessLog(
  orgId?: string | null,
  filters: AccessLogFilters = {},
) {
  const [entries, setEntries] = useState<EducationRecordAccessLogEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const q = filters.q?.trim() || undefined;
  const action = filters.action?.trim() || undefined;

  const load = useCallback(
    async (nextOffset: number) => {
      setLoading(true);
      setError(false);
      try {
        const result = await listEducationRecordAccessLog({
          orgId: orgId || undefined,
          q,
          action,
          limit: PAGE_SIZE,
          offset: nextOffset,
        });
        setEntries(result.entries);
        setTotal(result.total);
        setOffset(nextOffset);
      } catch {
        setEntries([]);
        setTotal(0);
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    [orgId, q, action],
  );

  useEffect(() => {
    void load(0);
  }, [load]);

  return {
    entries,
    total,
    offset,
    pageSize: PAGE_SIZE,
    loading,
    error,
    reload: () => load(offset),
    goToPage: (page: number) => load(Math.max(0, page) * PAGE_SIZE),
  };
}
